export default __webpack_public_path__ + "static/media/icon-family-blue.b1812599.svg";